import {
  GET_PLANS_REQUEST,
  GET_PLANS,
  CREATE_PLAN_REQUEST,
  CREATE_PLAN,
  GET_SUBSCRIPTIONS_REQUEST,
  GET_SUBSCRIPTIONS,
  GET_SUBSCRIPTION_REQUEST,
  GET_SUBSCRIPTION,
  CREATE_SUBSCRIPTION_REQUEST,
  CREATE_SUBSCRIPTION,
  UPDATE_SUBSCRIPTION_REQUEST,
  UPDATE_SUBSCRIPTION,
  UPDATE_PLAN_REQUEST,
  GET_CUSTOMER_SUBSCRIPTIONS_REQUEST,
  GET_CUSTOMER_SUBSCRIPTIONS,
} from '../types/subscriptions'

export const getPlans = () => ({ type: GET_PLANS_REQUEST })
export const setPlans = (payload) => ({ type: GET_PLANS, payload })
export const createPlan = (payload) => ({ type: CREATE_PLAN_REQUEST, payload })
export const updatePlan = (payload) => ({ type: UPDATE_PLAN_REQUEST, payload })

export const getSubscriptions = () => ({ type: GET_SUBSCRIPTIONS_REQUEST })
export const setSubscriptions = (payload) => ({ type: GET_SUBSCRIPTIONS, payload })
export const getSubscription = (payload) => ({ type: GET_SUBSCRIPTION_REQUEST, payload })
export const setSubscription = (payload) => ({ type: GET_SUBSCRIPTION, payload })
export const createSubscription = (payload) => ({ type: CREATE_SUBSCRIPTION_REQUEST, payload })
export const updateSubscription = (payload) => ({ type: UPDATE_SUBSCRIPTION_REQUEST, payload })

export const getCustomerSubscriptions = (payload) => ({
  type: GET_CUSTOMER_SUBSCRIPTIONS_REQUEST,
  payload,
})
export const setCustomerSubscriptions = (payload) => ({ type: GET_CUSTOMER_SUBSCRIPTIONS, payload })
